import styles from './Hero.module.css';
import shared from '../HomePage.module.css';

/**
 * ═══ HERO ═══ (파란 배경 메인 히어로)
 * 원본 마크업 그대로 hero-tv-stage(TV 프레임 안의 일반 <video>) 디자인을 사용한다.
 * CSS에만 남아있던 크로마키(.hero-video-stage)·캐릭터 스테이지(.hero-character-stage)
 * 디자인은 실제 본문에서 쓰이지 않는 죽은 마크업이라 포팅하지 않았다(hooks/useKeyedHeroVideo.js 참고).
 */
export default function Hero() {
  return (
    <section className={`${shared.section} ${styles.hero}`}>
      <div className={styles.heroBlob}></div>
      <div className={`wrap ${styles.heroInner}`}>
        <div className={styles.heroText}>
          <span className={styles.heroBadge}>비상교육 6~9세 영어 프랜차이즈</span>
          <h1>
            <em>즐겁게</em> 시작하고
            <br />
            습관으로 <em>성장</em>하는 영어
          </h1>
          <p className={`${styles.heroTagline} en`}>Fun to Start, Growing into English!</p>
          <p>
            아이의 언어적 잠재력이 스마트 시스템을 만나 기분{' '}좋게{' '}터져{' '}나오는 결정적
            순간을 만듭니다.
          </p>
          <div className={styles.heroCtaRow}>
            <a href="#levels" className={`${shared.btn} ${shared.btnPrimary}`}>
              레벨 시스템 보기
            </a>
          </div>
        </div>
        <div className={styles.heroVisual}>
          <div className={styles.heroTvStage} aria-label="English POP character video">
            <div className={styles.heroTvFrame}>
              <div className={styles.heroTvScreen}>
                <video src="/assets/samplecha.mp4" autoPlay muted loop playsInline preload="auto"></video>
              </div>
              <div className={styles.heroTvBar}>
                <div className={styles.heroTvLights} aria-hidden="true">
                  <span className={styles.red}></span>
                  <span className={styles.yellow}></span>
                  <span className={styles.green}></span>
                </div>
                <span>ABC SONG · ON AIR</span>
              </div>
            </div>
            <div className={styles.heroTvShadow} aria-hidden="true"></div>
          </div>
        </div>
      </div>
      <div className={styles.heroTrust}>
        <div className={`wrap ${styles.heroTrustInner}`}>
          <div className={styles.heroTrustItem}>
            <b>6단계</b>
            <span>체계적 레벨 시스템</span>
          </div>
          <div className={styles.heroTrustItem}>
            <b>6~9세</b>
            <span>결정적 시기 집중</span>
          </div>
          <div className={styles.heroTrustItem}>
            <b>인지 성장</b>
            <span>학습 기질 데이터 생성</span>
          </div>
          <div className={styles.heroTrustItem}>
            <b>VISANG</b>
            <span>비상교육의 독보적 콘텐츠</span>
          </div>
        </div>
      </div>
    </section>
  );
}
